import React, { useContext, Fragment } from 'react';
import ReactPaginate from 'react-paginate';
import EventCard from '../EventCard';
import { EventMapContext } from '../../context/EventMapContext';
import NoResults from '../NoResults';
import LoadingCard from '../Loading/LoadingCard';

const EventsCards = ({ eventCardMap, events, loading, meta }) => {
  const { currentPage, setCurrentPage } = useContext(EventMapContext);

  return (
    <div
      style={{ justifyContent: 'none', height: '100%' }}
      className={`card-section events-card-section ${
        !events.length ? 'no-events' : ''
      }`}
    >
      {events.length ? (
        <Fragment>
          {events.map(event => (
            <EventCard
              key={event.id}
              event={event}
              eventCardMap={eventCardMap}
            />
          ))}
          <section className="card-section-footer">
            {parseInt(meta.total_count) > parseInt(meta.per_page) && (
              <ReactPaginate
                pageCount={parseInt(meta.total_pages)}
                pageRangeDisplayed={2}
                marginPagesDisplayed={1}
                onPageChange={({ selected }) => {
                  setCurrentPage(Math.min(selected + 1, meta.total_pages));
                }}
                forcePage={currentPage - 1}
                containerClassName="pagination"
                pageClassName="page"
                activeClassName="current"
                nextClassName="next"
                previousClassName="prev"
                breakClassName="page gap"
                nextLabel=""
                previousLabel=""
              />
            )}
            <p>
              {meta.per_page * currentPage - meta.per_page + 1} -{' '}
              {Math.min(meta.per_page * currentPage, meta.total_count)} of{' '}
              {meta.total_count} <span>Events</span>
            </p>
          </section>
        </Fragment>
      ) : (
        <Fragment>
          {loading ? (
            [...Array(10)].map((_, ind) => (
              <LoadingCard key={ind} card_type="events" />
            ))
          ) : (
            <NoResults />
          )}
        </Fragment>
      )}
    </div>
  );
};

export default EventsCards;
